import "./App.css";
import Index from "./pages/index";
import Login from "./pages/login";
import HanderComponen from "./componens/handerComponen";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <HanderComponen />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<Index />} />
      </Routes>
    </Router>
  );
}

export default App;
